import { required } from '@sequencehq/utils/validation'
import {
  ScheduleValidationData,
  ValidationResults
} from 'modules/Cube/domain/cube.domain.types'
import { adaptValidationFromLib } from 'modules/Cube/domain/postActionStages/validation/util/adaptValidatorFromLib'
import { atLeastOnePhase } from 'modules/Cube/domain/postActionStages/validation/validators/atLeastOnePhase'
import { atLeastOnePriceInPhase } from 'modules/Cube/domain/postActionStages/validation/validators/phases/atLeastOnePriceInPhase'
import { noIncompatibleDiscountProration } from 'modules/Cube/domain/postActionStages/validation/validators/phases/noIncompatibleDiscountProration'
import { noIncompatibleMinimumProration } from 'modules/Cube/domain/postActionStages/validation/validators/phases/noIncompatibleMinimumProration'
import { noIncompatiblePriceProration } from 'modules/Cube/domain/postActionStages/validation/validators/phases/noIncompatiblePriceProration'
import { nonFinalPhaseHasDuration } from 'modules/Cube/domain/postActionStages/validation/validators/phases/nonFinalPhaseHasDuration'
import { taxRateRequired } from 'modules/Cube/domain/postActionStages/validation/validators/schedule/taxRateRequired'

type PublishScheduleValidation = (
  data: ScheduleValidationData
) => ValidationResults

export const publishScheduleValidation: PublishScheduleValidation = data => {
  return {
    common: {
      currency: null,
      customerId: adaptValidationFromLib(required(data.data.common.customerId)),
      phaseIds: atLeastOnePhase(data),
      phases: data.queries.orderedPhases.reduce(
        (acc, resolvedPhase) => ({
          ...acc,
          [resolvedPhase.id]: {
            prices: [
              atLeastOnePriceInPhase({ phaseId: resolvedPhase.id })(data),
              noIncompatiblePriceProration({ phaseId: resolvedPhase.id })(data),
              noIncompatibleDiscountProration({ phaseId: resolvedPhase.id })(
                data
              ),
              noIncompatibleMinimumProration({ phaseId: resolvedPhase.id })(
                data
              )
            ]
              .filter(Boolean)
              .flatMap(validationResult => validationResult),
            duration: nonFinalPhaseHasDuration({ phaseId: resolvedPhase.id })(
              data
            )
          }
        }),
        {}
      ),
      startDate: adaptValidationFromLib(required(data.data.common.startDate)),
      title: null
    },
    schedule: {
      recurrenceDayOfMonth: adaptValidationFromLib(
        required(data.data.schedule.recurrenceDayOfMonth)
      ),
      taxRate: taxRateRequired(data),
      defaultDueDateDays: null,
      memo: null
    },
    quote: {
      dealType: null,
      expiry: null,
      presentation: null,
      quoteNumber: null,
      contactIds: null,
      counterSigners: null,
      contractDuration: null,
      amendmentDate: null
    }
  }
}
